import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import RelaxModel from "Base/model/RelaxModel";

export default class BaseAutoPlaySelectCountContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.mode = 1;
        this.checkBoxes = [];

        this.init();
    }

    init() {
        for (let i = 1; i <= 5; i++) {
            let checkBox = this.getChildByName('count_' + i);
            let count = EntryPoint.AutoPlaySettings.possibleCounts[i - 1];
            checkBox.value = count;
            checkBox.checked = checkBox.value === EntryPoint.AutoPlaySettings.selectedCount;
            checkBox.enabled = !checkBox.checked;
            checkBox.actions = {
                checked: {
                    callback: this.onCountChecked, context: this, params: checkBox
                }
            };
            if (count > RelaxModel.maxAutoplayCount) {
                checkBox.visible = false;
            } else {
                this.checkBoxes.push(checkBox);
            }
        }
    }

    onCountChecked(data) {
        EntryPoint.AutoPlaySettings.selectedCount = data.value;
        if (this.mode === 1) {
            EntryPoint.AutoPlaySettings.active = true;
        }
        this.setChecked();
    }

    setChecked() {
        this.checkBoxes.forEach((checkBox, index) => {
            checkBox.checked = checkBox.value === EntryPoint.AutoPlaySettings.selectedCount;
            checkBox.enabled = !checkBox.checked;
        });
    }

    setMode(value) {
        this.mode = value;
        if(this.mode === 1) {
            this.reset();
        } else {
            this.setChecked();
        }
    }

    reset() {
        this.checkBoxes.forEach((checkBox, index) => {
            checkBox.checked = false;
            checkBox.enabled = true;
        });
    }
}